/**
 * Clicks and hovers on the front screens (the login, the character select, the splash: `#front`,
 * `#splash`), listened for on the document so those screens need no change. The first press there
 * also asks for the audio context (browsers allow it only from a gesture).
 */
import { uiSfx } from './api';
import { sfxEngine } from './engine';

const SELECTOR = '#front button, #front a, #front [role="button"], #front [role="tab"], #splash button';

function target(ev: Event): Element | null {
  const t = ev.target;
  return t instanceof Element ? t.closest(SELECTOR) : null;
}

if (typeof document !== 'undefined') {
  let over: Element | null = null;
  document.addEventListener(
    'pointerover',
    (ev) => {
      const el = target(ev);
      if (el && el !== over && !(el as HTMLButtonElement).disabled) uiSfx.hover();
      over = el;
    },
    { passive: true },
  );
  document.addEventListener(
    'pointerdown',
    (ev) => {
      if (target(ev)) sfxEngine.requestUnlock();
    },
    { capture: true, passive: true },
  );
  document.addEventListener(
    'click',
    (ev) => {
      const el = target(ev);
      if (el && !(el as HTMLButtonElement).disabled) uiSfx.click();
    },
    { capture: true, passive: true },
  );
}
